import React, { useContext, useEffect, useState } from "react"
import { UserContext } from '../utils/usermanagement'
import { NotificationContext } from "./../utils/notification";
import { useQueryParam, StringParam } from "use-query-params";

const ResendVerification = ({ locationData, ctaText, ctaType, isExpired }) => {
  const [userState, userDispatch] = useContext(UserContext);
  const [notificationState, setNotificationState] = useContext(NotificationContext);	// eslint-disable-line no-unused-vars
  var ctaCss = '';
  var ctaCssDis = '';
  if(ctaType === 'link'){
    ctaCss = '';
    ctaCssDis = '';
  }else{
    ctaCss = 'btn btn-highlight';
    ctaCssDis = 'btn btn-highlight disabled';
  }

  const [ctaState, setCtaState] = useState(ctaCss);
  const [address, setAddress] = useQueryParam("a", StringParam);
  const [code, setCode] = useQueryParam("c", StringParam);								// eslint-disable-line no-unused-vars

  const resendSignUpDispatcher = (e) => {
	e.preventDefault();
    var userName = '';

    if(locationData != null) {
      if(locationData?.state)
       userName = locationData?.state?.username;
      else
      userName = locationData;

    }else if(address){
      userName = address;
    }

    if(userName){
      userDispatch({action: 'resendsignup',
  		data: {
  			username: userName, //username
  			}
  		});
    }
  };

  useEffect(() => {
    //set notification
	if( userState.code == 'RESENDSIGNUP_SUCCESS'){
		setNotificationState({action: 'add', data: {
			"html": 'Verification email sent.'
		}});
		setCtaState(ctaCssDis);
	}
  }, [ userState.code, userState.message, userDispatch ]);

  return(
    <button onClick={resendSignUpDispatcher} className={ctaState}
		data-analytics={`{"event":"resendEmail", "eventCategory":"Account verification - Engagement", "eventAction":"CTA Click", "eventLabel":"${isExpired?"Link expired so click here to resend":"Resend email"}"}`}>
			{ctaText? ctaText : 'Resend email'}
	</button>
  )
}

export default ResendVerification
